import { DefaultTheme } from '@react-navigation/native'
import { colorList } from 'utils/colors'
import i18n from 'utils/i18n'

export const navigationContainerProps = {
	theme: {
		...DefaultTheme,
		dark: false,
		colors: {
			...DefaultTheme.colors,
			background: colorList.PAGE.primary,
			primary: colorList.PRIMARY.primary,
			flex: 1,
		}
	},
	documentTitle: {
		formatter: (options, route) => {
			if( options?.title === i18n.t('app_name') ) {
				return i18n.t('app_name')
			}
			
			return `${ options?.title ?? ( i18n.exists(`titles.${ route?.name }`) ? i18n.t(`titles.${ route?.name }`) : route?.name ) } - ${ i18n.t('app_name') }`
		},
	},
	linking: true
}
